import { useState, useEffect } from 'react';

const PASSWORD = '962WayneSilver';
const COOKIE_NAME = 'site_unlocked';
const COOKIE_DAYS = 30;

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1];
}

export default function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (document.URL.includes('www')) {
      setUnlocked(true);
    }

    if (getCookie(COOKIE_NAME) === 'true') {
      setUnlocked(true);
    }
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    if (input === PASSWORD) {
      setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
      setUnlocked(true);
    } else {
      setError(true);
    }
  }

  if (unlocked) return children;

  return (
    <div style={{
      position: 'fixed', inset: 0, display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: '#111', zIndex: 9999
    }}>
      <form onSubmit={handleSubmit} style={{ textAlign: 'center', color: '#fff' }}>
        <p>This site is password protected</p>
        <input
          type="password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(false); }}
          autoFocus
          style={{ padding: 8, fontSize: 16 }}
        />
        <br />
        <button type="submit" style={{ marginTop: 10, padding: '8px 16px' }}>
          Enter
        </button>
        {error && <p style={{ color: 'tomato' }}>Wrong password</p>}
      </form>
    </div>
  );
}